// import { useState, useEffect } from 'react';
// import { Form, Alert, Button } from 'react-bootstrap';
// import { CheckCircle, AlertCircle, AlertTriangle, Eye, EyeOff } from 'lucide-react';

// function checkPasswordStrength(password) {
//   if (!password) {
//     return { strength: 'very-weak', message: 'Very Weak' };
//   }

//   let score = 0;

//   // Length check
//   if (password.length >= 8) score++;
//   if (password.length >= 12) score++;

//   // Contains number
//   if (/\d/.test(password)) score++;

//   // Contains lowercase
//   if (/[a-z]/.test(password)) score++;

//   // Contains uppercase
//   if (/[A-Z]/.test(password)) score++;

//   // Contains special character
//   if (/[!@#$%^&*(),.?":{}|<>]/.test(password)) score++;

//   switch (true) {
//     case score >= 5:
//       return { strength: 'strong', message: 'Strong' };
//     case score >= 3:
//       return { strength: 'medium', message: 'Medium' };
//     case score >= 1:
//       return { strength: 'weak', message: 'Weak' };
//     default:
//       return { strength: 'very-weak', message: 'Very Weak' };
//   }
// }

// export function LoginInformation() {
//   const [newPassword, setNewPassword] = useState('');
//   const [repeatPassword, setRepeatPassword] = useState('');
//   const [showNewPassword, setShowNewPassword] = useState(false);
//   const [showRepeatPassword, setShowRepeatPassword] = useState(false);
//   const [passwordStrength, setPasswordStrength] = useState({
//     strength: 'very-weak',
//     message: 'Very Weak'
//   });

//   useEffect(() => {
//     setPasswordStrength(checkPasswordStrength(newPassword));
//   }, [newPassword]);

//   const togglePasswordVisibility = (type) => {
//     if (type === 'new') {
//       setShowNewPassword(!showNewPassword);
//     } else if (type === 'repeat') {
//       setShowRepeatPassword(!showRepeatPassword);
//     }
//   };

//   const getPasswordStrengthAlert = () => {
//     if (!newPassword) return null;

//     const variants = {
//       strong: 'success',
//       medium: 'warning',
//       weak: 'warning',
//       'very-weak': 'danger'
//     };

//     const icons = {
//       strong: <CheckCircle className="me-2" size={16} />,
//       medium: <AlertTriangle className="me-2" size={16} />,
//       weak: <AlertTriangle className="me-2" size={16} />,
//       'very-weak': <AlertCircle className="me-2" size={16} />
//     };

//     return (
//       <Alert 
//         variant={variants[passwordStrength.strength]} 
//         className="mb-4"
//       >
//         <div className="d-flex align-items-center">
//           {icons[passwordStrength.strength]}
//           {passwordStrength.message}
//         </div>
//       </Alert>
//     );
//   };

//   return (
//     <div className="flex-grow-1">
//       <h2 className="h3 mb-4 text-center">Login Information</h2>

//       <Form className="max-width-md mx-auto">
//         <Form.Group className="mb-4 position-relative">
//           <Form.Label
//             htmlFor="current-password"
//             className="text-secondary mb-2 d-block"
//           >
//             Current Password
//             <span className="text-muted small">
//               (required to update email or change current password)
//             </span>
//           </Form.Label>
//           <Form.Control
//             id="current-password"
//             type={showNewPassword ? "text" : "password"}
//             className="form-control-lg"
//             placeholder="Enter current password"
//           />
//           <Button
//             variant="link"
//             className="position-absolute top-50 end-0 translate-middle-y me-2"
//             style={{ paddingTop: "40px" }}
//             onClick={() => togglePasswordVisibility("new")}
//             aria-label={showNewPassword ? "Hide password" : "Show password"}
//           >
//             {showNewPassword ? <EyeOff size={20} /> : <Eye size={20} />}
//           </Button>
//         </Form.Group>

//         <a
//           href="#"
//           className="d-block mb-4 text-primary text-decoration-none"
//           onClick={(e) => {
//             e.preventDefault();
//           }}
//         >
//           Lost your password?
//         </a>

//         <Form.Group className="mb-4">
//           <Form.Label className="text-secondary mb-2">Account Email</Form.Label>
//           <Form.Control
//             type="email"
//             value=" "
//             className="form-control-lg bg-light"
//           />
//         </Form.Group>

//         <Alert
//           variant="primary"
//           className="d-flex align-items-center mb-4 bg-light border-0"
//         >
//           <i className="bi bi-info-circle me-2"></i>
//           Leave password fields blank for no change
//         </Alert>

//         <Form.Group className="mb-4 position-relative">
//           <Form.Label className="text-secondary mb-2">
//             Add Your New Password
//           </Form.Label>
//           <Form.Control
//             type={showNewPassword ? "text" : "password"}
//             className="form-control-lg pe-5" // Add padding to the end
//             value={newPassword}
//             onChange={(e) => setNewPassword(e.target.value)}
//           />
//           <Button
//             variant="link"
//             className="position-absolute top-50 end-0 translate-middle-y me-2"
//             style={{ paddingTop: "40px" }}
//             onClick={() => togglePasswordVisibility("new")}
//           >
//             {showNewPassword ? <EyeOff size={20} /> : <Eye size={20} />}
//           </Button>
//         </Form.Group>

//         <Alert variant="info" className="mb-4">
//           <h5 className="mb-2">Tips for a Strong Password:</h5>
//           <ul className="mb-0">
//             <li>Use at least 8 characters (12+ recommended).</li>
//             <li>Include numbers, uppercase and lowercase letters.</li>
//             <li>Add special characters like @, #, $, etc.</li>
//             <li>Avoid using easily guessable patterns.</li>
//             <li>Ensure your password is unique and not reused.</li>
//           </ul>
//         </Alert>

//         <Form.Group className="mb-4 position-relative">
//           <Form.Label className="text-secondary mb-2">
//             Repeat Your New Password
//           </Form.Label>
//           <Form.Control
//             type={showRepeatPassword ? "text" : "password"}
//             className="form-control-lg"
//             value={repeatPassword}
//             onChange={(e) => setRepeatPassword(e.target.value)}
//           />
//           <Button
//             variant="link"
//             className="position-absolute top-50 end-0 translate-middle-y me-2"
//             style={{ paddingTop: "40px" }}
//             onClick={() => togglePasswordVisibility("repeat")}
//           >
//             {showRepeatPassword ? <EyeOff size={20} /> : <Eye size={20} />}
//           </Button>
//         </Form.Group>

//         {getPasswordStrengthAlert()}

//         <Button variant="primary" size="lg" className="px-4 d-block mx-auto">
//           Save Changes
//         </Button>
//       </Form>
//     </div>
//   );
// }

// import { useState, useEffect } from 'react';
// import { Form, Alert, Button } from 'react-bootstrap';
// import { CheckCircle, AlertCircle, AlertTriangle, Eye, EyeOff } from 'lucide-react';
 
// function checkPasswordStrength(password) {
//   if (!password) {
//     return { strength: 'very-weak', message: 'Very Weak' };
//   }
 
//   let score = 0;
 
//   // Length check
//   if (password.length >= 8) score++;
//   if (password.length >= 12) score++;
 
//   // Contains number
//   if (/\d/.test(password)) score++;
 
//   // Contains lowercase
//   if (/[a-z]/.test(password)) score++;
 
//   // Contains uppercase
//   if (/[A-Z]/.test(password)) score++;
 
//   // Contains special character
//   if (/[!@#$%^&*(),.?":{}|<>]/.test(password)) score++;
 
//   switch (true) {
//     case score >= 5:
//       return { strength: 'strong', message: 'Strong' };
//     case score >= 3:
//       return { strength: 'medium', message: 'Medium' };
//     case score >= 1:
//       return { strength: 'weak', message: 'Weak' };
//     default:
//       return { strength: 'very-weak', message: 'Very Weak' };
//   }
// }
 
// export function LoginInformation() {
//   const [newPassword, setNewPassword] = useState('');
//   const [repeatPassword, setRepeatPassword] = useState('');
//   const [showNewPassword, setShowNewPassword] = useState(false);
//   const [showRepeatPassword, setShowRepeatPassword] = useState(false);
//   const [passwordStrength, setPasswordStrength] = useState({
//     strength: 'very-weak',
//     message: 'Very Weak'
//   });
//   const [email, setEmail] = useState('');
 
//   useEffect(() => {
//     setPasswordStrength(checkPasswordStrength(newPassword));
//   }, [newPassword]);
 
//   const togglePasswordVisibility = (type) => {
//     if (type === 'new') {
//       setShowNewPassword(!showNewPassword);
//     } else if (type === 'repeat') {
//       setShowRepeatPassword(!showRepeatPassword);
//     }
//   };
 
//   const getPasswordStrengthAlert = () => {
//     if (!newPassword) return null;
 
//     const variants = {
//       strong: 'success',
//       medium: 'warning',
//       weak: 'warning',
//       'very-weak': 'danger'
//     };
 
//     const icons = {
//       strong: <CheckCircle className="me-2" size={16} />,
//       medium: <AlertTriangle className="me-2" size={16} />,
//       weak: <AlertTriangle className="me-2" size={16} />,
//       'very-weak': <AlertCircle className="me-2" size={16} />
//     };
 
//     return (
//       <Alert
//         variant={variants[passwordStrength.strength]}
//         className="mb-4"
//       >
//         <div className="d-flex align-items-center">
//           {icons[passwordStrength.strength]}
//           {passwordStrength.message}
//         </div>
//       </Alert>
//     );
//   };
 
//   return (
//     <div className="flex-grow-1">
//       <h2 className="h3 mb-4 text-center">Login Information</h2>
 
//       <Form className="max-width-md mx-auto">
//         <Form.Group className="mb-4 position-relative">
//           <Form.Label htmlFor="current-password" className="text-secondary mb-2 d-block">
//             Current Password
//             <span className="text-muted small">
//               (required to update email or change current password)
//             </span>
//           </Form.Label>
//           <Form.Control
//             id="current-password"
//             type={showNewPassword ? "text" : "password"}
//             className="form-control-lg"
//             placeholder="Enter current password"
//           />
//           <Button
//             variant="link"
//             className="position-absolute top-50 end-0 translate-middle-y me-2"
//             style={{ paddingTop: "40px" }}
//             onClick={() => togglePasswordVisibility("new")}
//             aria-label={showNewPassword ? "Hide password" : "Show password"}
//           >
//             {showNewPassword ? <EyeOff size={20} /> : <Eye size={20} />}
//           </Button>
//         </Form.Group>
 
//         <a
//           href="#"
//           className="d-block mb-4 text-primary text-decoration-none"
//           onClick={(e) => {
//             e.preventDefault();
//           }}
//         >
//           Lost your password?
//         </a>
 
//         <Form.Group className="mb-4">
//           <Form.Label className="text-secondary mb-2">Account Email</Form.Label>
//           <Form.Control
//             type="email"
//             value={email}
//             className="form-control-lg bg-light"
//             onChange={(e) => setEmail(e.target.value)}
//             placeholder="Enter your email"
//           />
//         </Form.Group>
 
//         <Alert
//           variant="primary"
//           className="d-flex align-items-center mb-4 bg-light border-0"
//         >
//           <i className="bi bi-info-circle me-2"></i>
//           Leave password fields blank for no change
//         </Alert>
 
//         <Form.Group className="mb-4 position-relative">
//           <Form.Label className="text-secondary mb-2">
//             Add Your New Password
//           </Form.Label>
//           <Form.Control
//             type={showNewPassword ? "text" : "password"}
//             className="form-control-lg pe-5"
//             value={newPassword}
//             onChange={(e) => setNewPassword(e.target.value)}
//           />
//           <Button
//             variant="link"
//             className="position-absolute top-50 end-0 translate-middle-y me-2"
//             style={{ paddingTop: "40px" }}
//             onClick={() => togglePasswordVisibility("new")}
//           >
//             {showNewPassword ? <EyeOff size={20} /> : <Eye size={20} />}
//           </Button>
//         </Form.Group>
 
//         <Alert variant="info" className="mb-4">
//           <h5 className="mb-2">Tips for a Strong Password:</h5>
//           <ul className="mb-0">
//             <li>Use at least 8 characters (12+ recommended).</li>
//             <li>Include numbers, uppercase and lowercase letters.</li>
//             <li>Add special characters like @, #, $, etc.</li>
//             <li>Avoid using easily guessable patterns.</li>
//             <li>Ensure your password is unique and not reused.</li>
//           </ul>
//         </Alert>
 
//         <Form.Group className="mb-4 position-relative">
//           <Form.Label className="text-secondary mb-2">
//             Repeat Your New Password
//           </Form.Label>
//           <Form.Control
//             type={showRepeatPassword ? "text" : "password"}
//             className="form-control-lg"
//             value={repeatPassword}
//             onChange={(e) => setRepeatPassword(e.target.value)}
//           />
//           <Button
//             variant="link"
//             className="position-absolute top-50 end-0 translate-middle-y me-2"
//             style={{ paddingTop: "40px" }}
//             onClick={() => togglePasswordVisibility("repeat")}
//           >
//             {showRepeatPassword ? <EyeOff size={20} /> : <Eye size={20} />}
//           </Button>
//         </Form.Group>
 
//         {getPasswordStrengthAlert()}
 
//         <Button variant="primary" size="lg" className="px-4 d-block mx-auto">
//           Save Changes
//         </Button>
//       </Form>
//     </div>
//   );
// }


import { useState, useEffect } from 'react';
import { Form, Alert, Button, Spinner } from 'react-bootstrap';
import Swal from 'sweetalert2';
import { CheckCircle, AlertCircle, AlertTriangle, Eye, EyeOff } from 'lucide-react';
import { Link } from 'react-router-dom';

function checkPasswordStrength(password) {
  if (!password) return { strength: 'very-weak', message: 'Very Weak' };

  let score = 0;
  if (password.length >= 8) score++;
  if (password.length >= 12) score++;
  if (/\d/.test(password)) score++;
  if (/[a-z]/.test(password)) score++;
  if (/[A-Z]/.test(password)) score++;
  if (/[!@#$%^&*(),.?":{}|<>]/.test(password)) score++;

  switch (true) {
    case score >= 5: return { strength: 'strong', message: 'Strong' };
    case score >= 3: return { strength: 'medium', message: 'Medium' };
    case score >= 1: return { strength: 'weak', message: 'Weak' };
    default: return { strength: 'very-weak', message: 'Very Weak' };
  }
}

export function LoginInformation() {
  const [email, setEmail] = useState('');
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [repeatPassword, setRepeatPassword] = useState('');
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showRepeatPassword, setShowRepeatPassword] = useState(false);
  const [passwordStrength, setPasswordStrength] = useState({ strength: 'very-weak', message: 'Very Weak' });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setPasswordStrength(checkPasswordStrength(newPassword));
  }, [newPassword]);

  const togglePasswordVisibility = (type) => {
    if (type === 'new') setShowNewPassword(!showNewPassword);
    else if (type === 'repeat') setShowRepeatPassword(!showRepeatPassword);
  };

  const getPasswordStrengthAlert = () => {
    if (!newPassword) return null;

    const variants = {
      strong: 'success',
      medium: 'warning',
      weak: 'warning',
      'very-weak': 'danger',
    };

    const icons = {
      strong: <CheckCircle className="me-2" size={16} />,
      medium: <AlertTriangle className="me-2" size={16} />,
      weak: <AlertTriangle className="me-2" size={16} />,
      'very-weak': <AlertCircle className="me-2" size={16} />,
    };

    return (
      <Alert variant={variants[passwordStrength.strength]} className="mb-4">
        <div className="d-flex align-items-center">
          {icons[passwordStrength.strength]} {passwordStrength.message}
        </div>
      </Alert>
    );
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (newPassword !== repeatPassword) {
      Swal.fire({
        icon: 'error',
        title: 'Password Mismatch',
        text: 'New password and repeat password do not match.',
      });
      return;
    }

    setLoading(true);

    // Simulate a save request
    setTimeout(() => {
      setLoading(false);
      Swal.fire({
        icon: 'success',
        title: 'Changes Saved',
        text: 'Your login information has been updated successfully.',
        showConfirmButton: false,
        timer: 2000
      });
    }, 1500);
  };

  return (
    <div className="flex-grow-1">
      <h2 className="fi mb-4 text-center">Login Information</h2>

      <Form onSubmit={handleSubmit} className="max-width-md mx-auto">

        {/* Email first */}
        <Form.Group className="mb-4">
          <Form.Label className="text-secondary mb-2">Account Email</Form.Label>
          <Form.Control
            type="email"
            value={email}
            className="form-control-lg bg-light"
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Enter your email"
            required
          />
        </Form.Group>

        <Form.Group className="mb-4 position-relative">
          <Form.Label className="text-secondary mb-2 d-block">
            Current Password
            <span className="text-muted small">
              (required to update email or change current password)
            </span>
          </Form.Label>
          <Form.Control
            id="current-password"
            type="password"
            className="form-control-lg"
            placeholder="Enter current password"
            value={currentPassword}
            onChange={(e) => setCurrentPassword(e.target.value)}
            required
          />
        </Form.Group>

       
<Link
  to="/reset-password"
  className="d-block mb-4 text-primary text-decoration-none"
>
  Forgot password?
</Link>

        <Alert
          variant="primary"
          className="d-flex align-items-center mb-4 bg-light border-0"
        >
          <i className="bi bi-info-circle me-2"></i>
          Leave password fields blank for no change
        </Alert>

        <Form.Group className="mb-4 position-relative">
          <Form.Label className="text-secondary mb-2">Add Your New Password</Form.Label>
          <Form.Control
            type={showNewPassword ? "text" : "password"}
            className="form-control-lg pe-5"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
          />
          <Button
            variant="link"
            className="position-absolute top-50 end-0 translate-middle-y me-2"
            style={{ paddingTop: "40px" }}
            onClick={() => togglePasswordVisibility("new")}
          >
            {showNewPassword ? <EyeOff size={20} /> : <Eye size={20} />}
          </Button>
        </Form.Group>

        {getPasswordStrengthAlert()}

        <Form.Group className="mb-4 position-relative">
          <Form.Label className="text-secondary mb-2">Repeat Your New Password</Form.Label>
          <Form.Control
            type={showRepeatPassword ? "text" : "password"}
            className="form-control-lg"
            value={repeatPassword}
            onChange={(e) => setRepeatPassword(e.target.value)}
          />
          <Button
            variant="link"
            className="position-absolute top-50 end-0 translate-middle-y me-2"
            style={{ paddingTop: "40px" }}
            onClick={() => togglePasswordVisibility("repeat")}
          >
            {showRepeatPassword ? <EyeOff size={20} /> : <Eye size={20} />}
          </Button>
        </Form.Group>

        <Alert variant="info" className="mb-4">
          <h5 className="mb-2">Tips for a Strong Password:</h5>
          <ul className="mb-0">
            <li>Use at least 8 characters (12+ recommended).</li>
            <li>Include numbers, uppercase and lowercase letters.</li>
            <li>Add special characters like @, #, $, etc.</li>
            <li>Avoid easily guessable patterns.</li>
            <li>Ensure your password is unique and not reused.</li>
          </ul>
        </Alert>

        <div className="text-center">
          <Button
            variant="primary"
            size="lg"
            type="submit"
            disabled={loading}
            className="px-5"
          >
            {loading ? (
              <>
                <Spinner animation="border" size="sm" className="me-2" />
                Saving...
              </>
            ) : (
              "Save Changes"
            )}
          </Button>
        </div>
      </Form>
    </div>
  );
}
